// ============================================================================
// UNIVERSAL ACTION HANDLERS - PDF FILL ACTIONS
// ============================================================================

import type { UniversalActionHandlers } from "./types";
import { fillPdfForm } from "@/lib/services/pdf-fill-service";

/**
 * PDF Fill Actions
 */
export const pdfFillActions: UniversalActionHandlers = {
  // Fill both checklists at once
  fillBothChecklists: async (item, context) => {
    try {
      context.onToast?.("Filling both PDFs with contact information...", "info");
      // Fill both PDFs in parallel - uses same generic function
      await Promise.all([
        fillPdfForm("client-fact-finding-checklist", item),
        fillPdfForm("telecom-fact-finding-checklist", item),
      ]);
      context.onToast?.("Both PDFs filled and downloaded successfully", "success");
    } catch (error) {
      console.error("Error filling both PDFs:", error);
      context.onToast?.("Failed to fill PDFs", "error");
    }
  },

  // Fill client checklist only
  fillClientChecklist: async (item, context) => {
    try {
      context.onToast?.("Filling client checklist...", "info");
      // Generic function - just pass templateId
      await fillPdfForm("client-fact-finding-checklist", item);
      context.onToast?.("Client checklist downloaded successfully", "success");
    } catch (error) {
      console.error("Error filling client checklist:", error);
      context.onToast?.("Failed to fill client checklist", "error");
    }
  },

  // Fill telecom checklist only
  fillTelecomChecklist: async (item, context) => {
    try {
      context.onToast?.("Filling telecom checklist...", "info");
      // Generic function - just pass templateId
      await fillPdfForm("telecom-fact-finding-checklist", item);
      context.onToast?.("Telecom checklist downloaded successfully", "success");
    } catch (error) {
      console.error("Error filling telecom checklist:", error);
      context.onToast?.("Failed to fill telecom checklist", "error");
    }
  },
};
